import jwt_decode from "jwt-decode";
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate, CanLoad {

  rejectedUserURL: string[] = ['admin', 'templatemanager', 'packagemanager',
    'softwareupdate', 'logs', 'foldermanager',
     'marketlocation', 'reportgenerator']
  constructor(private authService: AuthService, private router: Router,
    private activateRoute: ActivatedRoute
  ) {

  }



  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let tokenStored: string = localStorage.getItem('accessToken')
    if (!tokenStored) {
       this.getSSOTokenFromQueryString(next);
      if (this.router.url == "/admin-login") {
        this.router.navigate(['/admin-login']);
      }
      this.router.navigate(['/login']);
      return false;
    } else {
      let user_info_obj: any = jwt_decode(localStorage.getItem('accessToken'));
      if (user_info_obj?.role?.trim() == "operator") {
        if (this.rejectedUserURL.includes(next.routeConfig.path)) {
          this.router.navigate(['/404']);
          return false;
        }
      }
      return this.authService.check_auth(tokenStored)
    }
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return this.authService.check_auth(localStorage.getItem('accessToken'))
  }


   async getSSOTokenFromQueryString(next: ActivatedRouteSnapshot) {
    let receivedToken: string = next.queryParams.token
    if (receivedToken) {
      localStorage.setItem('accessToken', receivedToken);
      return await this.authService.check_auth(receivedToken)
    }
  }

}
